var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"margin-block"}),((_vm.role === 'master franchise' ||
			_vm.role === 'franchise' ||
			_vm.role === 'super franchise') &&
		!_vm.error
		)?_c('Franchise'):_vm._e(),(_vm.role === 'teacher' && !_vm.error)?_c('Teacher'):_vm._e(),(_vm.role === 'parent' && !_vm.error)?_c('Parent'):_vm._e(),(_vm.role === 'student' && !_vm.error)?_c('Student'):_vm._e(),(_vm.error)?_c('div',{staticClass:"error"},[_c('h1',{staticClass:"text-center"},[_vm._v("404")])]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }